import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6db7127f&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6db7127f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db7127f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db7127f')) {
      api.createRecord('6db7127f', component.options)
    } else {
      api.reload('6db7127f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6db7127f&scoped=true&lang=pug", function () {
      api.rerender('6db7127f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vipMgm/giftContentTwo/index.vue"
export default component.exports